/* eslint-disable no-unused-vars */

import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import { store } from './store'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import Paginate from 'vuejs-paginate'
import VueTruncate from 'vue-truncate-filter'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Multiselect from 'vue-multiselect'
import VueTheMask from 'vue-the-mask'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faNewspaper, faBarcode, faMapMarkerAlt, faCommentDots, faInfoCircle, faSignInAlt, faArrowCircleLeft, faSort, faClock, faShare, faAddressCard, faSignOutAlt, faList, faSuitcase, faMoneyBill,faEyeSlash,faEye } from '@fortawesome/free-solid-svg-icons'
import { faComment } from '@fortawesome/free-regular-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import SimpleVueValidation from 'simple-vue-validator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import GAuth from 'vue-google-oauth2'

const gauthOption = {
  clientId: '684115334333-ld7prbfd37b93k6atsbfs35e14njv8hp.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'consent',
  fetch_basic_profile: true
}

Vue.use(GAuth, gauthOption)
Vue.use(VueFormWizard)
Vue.use(VueSweetalert2);
Vue.use(SimpleVueValidation);
Vue.use(Loading);

library.add(
  faUser,
  faNewspaper,
  faBarcode,
  faMapMarkerAlt,
  faCommentDots,
  faInfoCircle,
  faSignInAlt,
  faArrowCircleLeft,
  faSort,
  faClock,
  faShare,
  faAddressCard,
  faSignOutAlt,
  faList,
  faSuitcase,
  faMoneyBill,
  faEyeSlash,
  faEye
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.config.productionTip = false

Vue.use(VueTheMask)

// register globally
Vue.component('multiselect', Multiselect)

// Global registration
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

//Vue.use(VueTheMask)

Vue.component('paginate', Paginate)

Vue.use(LayoutPlugin)

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(Vuex)
Vue.use(VueTruncate)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}
